export default __webpack_public_path__ + "static/card2-da55b7450f6ae94ead62713b6247dc02.png";